const BREAKPOINTS = {
  SM: '576px',
  MD: '768px',
  LG: '992px',
  XL: '1200px',
  XXL: '1400px'
}

export default BREAKPOINTS
